// removed by extract-text-webpack-plugin
module.exports = {"component":"_3M1dM3ABlqaFsZLoss2uNU","bg":"_3nSIu8nqqBLws9yWtN27Bk","col":"_2ktG4MDF82DE0yTPXt_1C_","colDiv":"_2_QE_AjjUWu-w_9xXfitla","select":"_2lMGF7_OqeqIrLEPMkU2mr"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ProductPreviewHeader/ProductPreviewHeader.scss
 ** module id = 1020
 ** module chunks = 0
 **/